/**
 * JQuery
 */

import $ from "jquery";

window.jQuery = $;
window.$ = $;

/**
 * Bootstrap
 */

import {
  // Alert,       // Dismissible alerts
  // Button,      // Toggle button states
  // Carousel,    // Slideshow component
  Collapse,    // Accordion-like collapsing elements
  // Dropdown,    // Dropdown menus
  Modal,       // Popup modals
  // Offcanvas,   // Offcanvas sidebars
  // Popover,     // Pop-up content on hover/click (requires @popperjs/core)
  // ScrollSpy,   // Auto-updating navigation based on scroll position
  // Tab,         // Tabs and pills navigation
  // Toast,       // Small pop-up notifications
  // Tooltip      // Tooltips for elements (requires @popperjs/core)
} from 'bootstrap';

window.Collapse = Collapse;
window.Modal = Modal;

/**
 * Swiper
 */

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

window.Swiper = Swiper;

/**
 * GSAP
 */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';


gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;


/**
 * Utils
 */

import scrollAnimations from "./js/utils/scrollAnimations";
scrollAnimations();

import modalVideo from "./js/utils/modalVideo";
modalVideo();

/**
 * Layout
 */

import navbar from "./js/layout/navbar";
navbar();

/**
 * Blocks
 */

import blockSlider from "./js/blocks/blockSlider";
blockSlider();

import blockProduts from "./js/blocks/blockProdutcs";
blockProduts();

import modalForm from "./js/blocks/modalForm";
modalForm();

document.addEventListener("DOMContentLoaded", () => {
  const anchors = document.querySelectorAll('a[href*="#"]')
  if (anchors.length > 0) {
    anchors.forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault()
        const offset = anchor.classList.contains('menu__link') ? 100 : 110;
        window.scrollTo({
          top: document.querySelector(this.getAttribute('href')).offsetTop - offset,
          behavior: 'smooth'
        })
      })
    });
  }
});